import apiService from './apiService';

class RakeMovementService {
  async getRakeMovements(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.skip !== undefined) queryParams.append('skip', params.skip);
    if (params.limit !== undefined) queryParams.append('limit', params.limit);
    if (params.port_id) queryParams.append('port_id', params.port_id);
    if (params.state_id) queryParams.append('state_id', params.state_id);
    if (params.district_id) queryParams.append('district_id', params.district_id);
    if (params.rr_number) queryParams.append('rr_number', params.rr_number);
    if (params.trip_number) queryParams.append('trip_number', params.trip_number);

    const queryString = queryParams.toString();
    const endpoint = `/api/v1/rake-movements/${queryString ? `?${queryString}` : ''}`;
    return await apiService.get(endpoint);
  }

  async getMyRakeMovements(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.skip !== undefined) queryParams.append('skip', params.skip);
    if (params.limit !== undefined) queryParams.append('limit', params.limit);
    if (params.state_id) queryParams.append('state_id', params.state_id);
    if (params.district_id) queryParams.append('district_id', params.district_id);
    if (params.rr_number) queryParams.append('rr_number', params.rr_number);
    if (params.trip_number) queryParams.append('trip_number', params.trip_number);

    const queryString = queryParams.toString();
    const endpoint = `/api/v1/rake-movements/my-trips${queryString ? `?${queryString}` : ''}`;
    return await apiService.get(endpoint);
  }

  async createRakeMovement(rakeData) {
    return await apiService.post('/api/v1/rake-movements/', rakeData);
  }

  async getRakePointsDropdown(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.state_id) queryParams.append('state_id', params.state_id);
    if (params.district_id) queryParams.append('district_id', params.district_id);
    if (params.point_type) queryParams.append('point_type', params.point_type);
    if (params.search) queryParams.append('search', params.search);

    const queryString = queryParams.toString();
    const endpoint = `/api/v1/rake-movements/rake-points/dropdown${queryString ? `?${queryString}` : ''}`;
    return await apiService.get(endpoint);
  }

  async getRakeMovementById(id) {
    return await apiService.get(`/api/v1/rake-movements/${id}`);
  }

  async updateRakeMovement(id, rakeData) {
    return await apiService.put(`/api/v1/rake-movements/${id}`, rakeData);
  }

  async deleteRakeMovement(id) {
    return await apiService.delete(`/api/v1/rake-movements/${id}`);
  }

  async receiveRakeMovement(id, data) {
    return await apiService.put(`/api/v1/rake-movements/${id}`, data);
  }

  async addMissingWagonReceipt(rakeMovementId, data) {
    return await apiService.post(`/api/v1/rake-movements/${rakeMovementId}/missing-wagon-receipts`, data);
  }

  async getMissingWagonReceipts(rakeMovementId) {
    return await apiService.get(`/api/v1/rake-movements/${rakeMovementId}/missing-wagon-receipts`);
  }
}

export default new RakeMovementService();
